import React from "react";
import { FormGroup, Button, Row, Col, Input } from "reactstrap";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { CardClip } from "../svgComponents";
import Alert from "../shared/common/alert";
import Play from "../../assets/images/verboden/play.png";
import arrowDown from "../../assets/images/tw/arrow-down.png";
import { getGameName } from "../../components/shared/utils";
import { validateCreateRoomFields } from "../shared/common/validation";
import * as gameAction from "../../redux/game/action";
import * as loaderAction from "../../redux/loader/action";
import Info from "../../assets/images/GAH/info.png";
import Select from "react-select";
import timed_game_switch from "../../assets/images/bingo/timed_game_switch.png";
import Socket from "../../socket/socket";
import * as paramsAction from "../../redux/gameParams/actions";
import TwHeader from "./TwHeader";
class GameData extends React.Component {
  constructor(props) {
    super(props);

    const gameName = props.gameReducer.gameName;
    // let nameOfGame = props.gameReducer.allGames[1].title || "The Word";
    let nameOfGame =
      // props?.gameReducer?.gamesData?.onboarding?.step_3?.games[1]?.label ||
      "The Word";
    if (gameName && gameName !== "" && gameName === "GAH") {
      // nameOfGame = props.gameReducer.allGames[0].title || "GIFs Against Society";

      nameOfGame =
        // props?.gameReducer?.gamesData?.onboarding?.step_3.games[0]?.label ||
        "GIFs Against Society";
    }

    this.state = {
      gifs: false,
      name: nameOfGame
    };
  }

  async componentDidMount() {
    this.removeListener = Socket.addListener("update-status", () => {
      this.props.history.push("/game");
    });
    const status = this.props?.gameReducer?.roomObj?.game_state?.status;
    let gameObj = this.props.gameReducer;
    let dataObj = {
      gameName:
        gameObj.gameName !== "" ? gameObj.gameName : gameObj.roomObj.game_code
    };
    this.props.getGameData(dataObj);
    console.log(this.props.paramsReducer, "this.props?.paramsReducer tw");
    if (status != "Joining") {
      if (Object.keys(this.props?.paramsReducer?.gameObj).length > 0) {
        this.props.history.push("/game");
      }
    }
    // if (this.props.webUrlReducer.viewerWebUrl) {
    //   if (status !== "Joining") {
    //     this.props.history.push("/game");
    //   }
    // }
  }
  componentWillUnmount() {
    this.removeListener();
  }
  componentDidUpdate() {
    const status = this.props?.gameReducer?.roomObj?.game_state?.status;
    // if (this.props.webUrlReducer.viewerWebUrl) {
    //   if (status !== "Joining") {
    //     this.props.history.push("/game");
    //   }
    // }
    if (status != "Joining") {
      if (Object.keys(this.props?.paramsReducer?.gameObj).length > 0) {
        this.props.history.push("/game");
      }
    }
  }
  handleChange = (e) => {
    const name = e.target.name;

    if (name === "gifs") {
      this.setState({ [name]: !this.state.gifs });
      return;
    } else {
      this.setState({ [name]: e.target.value });
      return;
    }
  };

  onStartGame = () => {
    let roomData = this.props.gameReducer.roomObj;
    const isValidData = validateCreateRoomFields(this.state);

    if (!isValidData) {
      return false;
    }
    if (roomData && roomData.users && roomData.users.length < 3) {
      Alert(400, "Need at least 3 players to start the game");
      return;
    }

    let value = "";
    if (this.props.rating.value === "General Audience (G)") {
      value = "g";
    } else if (this.props.rating.value === "Parental Guidance (PG)") {
      value = "pg-13";
    } else if (this.props.rating.value === "Adult (R)") {
      value = "r";
    } else if (this.props.rating.value === "Safe For Work (SFW)") {
      value = "sfw";
    }
    let data = {};
    if (roomData?.edition === "GAHW") {
      data = {
        action: "update-status",
        roomId: roomData.id,
        scoreToWin: parseInt(this.props.round),
        rating: "sfw",
        tableTopName: this.state.name,
        useGIFs: !this.state.gifs,
        safeForWork: true
      };
    } else if (roomData?.edition === "GAHF") {
      data = {
        action: "update-status",
        roomId: roomData.id,
        scoreToWin: parseInt(this.props.round),
        rating: "g",
        tableTopName: this.state.name,
        useGIFs: !this.state.gifs,
        safeForWork: false
      };
    } else {
      data = {
        action: "update-status",
        roomId: roomData.id,
        scoreToWin: parseInt(this.props.round),
        rating: value,
        tableTopName: this.state.name,
        useGIFs: !this.state.gifs,
        safeForWork: value === "sfw" ? true : false
      };
    }
    if (roomData && roomData.game_code === "TW") {
      data = {
        action: "update-status",
        roomId: roomData.id,
        maxRounds: parseInt(this.props.round),
        tableTopName: this.state.name
      };
    }
    Socket.sendMessage(data);
  };

  render() {
    let roomData = this.props.gameReducer.roomObj;
    let isDisabled = true;
    if (roomData && Object.keys(roomData).length > 0) {
      isDisabled = false;
    }

    const gameName = getGameName(roomData);

    const options = [
      { value: "Adult (R)", label: "Adult (R)" },
      { value: "Parental Guidance (PG)", label: "Parental Guidance (PG)" },
      { value: "General Audience (G)", label: "General Audience (G)" },
      { value: "Safe For Work (SFW)", label: "Safe For Work (SFW)" }
    ];

    const { location } = this.props;
    let displaybuttons = false;
    const { name } = this.state;
    if (location && location.pathname.includes("lobby")) {
      displaybuttons = true;
    }
    let buttonText = "Host’s “THE WORD” Game";
    if (gameName === "GAH") {
      buttonText = "Score to Win";
    }

    const { isCreateRoom = false } = this.props;
    const { rating } = this.props;
    let roundsForMapp =
      this.props.gameReducer.roomObj.lobby_parameters.rounds || 4;
    return (
      <>
        {gameName === "GAH" ? (
          <div className="wrapper d-flex align-items-end justify-content-between GAH-game-options">
            <div className="d-flex align-items-center ">
              <div className="gParameterRow gParameterRowGAH mr-5 mr-sm-3">
                <div>
                  <div className="labelWrapper">
                    <p>
                      {buttonText}{" "}
                      <button className="info">
                        <img src={Info} alt="" />
                      </button>
                    </p>
                  </div>

                  <div className="inpWrapper">
                    <div className="round">
                      <div className="counter">
                        <button
                          onClick={() =>
                            this.props.onAddOrSubtractRound("subtract", true)
                          }
                        >
                          -
                        </button>
                        <FormGroup className="mb-0 flex-grow-1">
                          <Input
                            min="1"
                            max="7"
                            type="number"
                            name="round"
                            onChange={(evt) => this.handleChange(evt)}
                            value={roundsForMapp}
                            disabled
                          />
                        </FormGroup>
                        <button
                          onClick={() =>
                            this.props.onAddOrSubtractRound("add", true)
                          }
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {!roomData?.edition ? (
                <div className="gParameterRow">
                  {gameName === "GAH" && (
                    <div className="labelWrapper">
                      <p>
                        Rating{" "}
                        <button className="info">
                          <img src={Info} alt="" />
                        </button>
                      </p>
                      <FormGroup className="mb-0">
                        <Select
                          value={
                            rating.label === "Parental Guidance (PG)"
                              ? { value: rating.value, label: "PG" }
                              : rating
                          }
                          name="rating"
                          className={`rating ${
                            this.props.blur ? "menuopen" : ""
                          }`}
                          options={options}
                          isSearchable={false}
                          classNamePrefix="rating"
                          onChange={this.props.onChangeNew}
                          onMenuOpen={() => {
                            this.props.onBlur();
                          }}
                          onMenuClose={() => {
                            this.props.onBlurOut();
                          }}
                        />
                      </FormGroup>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  {!roomData?.edition === "GAHW" ||
                    (!roomData?.edition === "GAHF" && <></>)}
                </>
              )}
            </div>
            <div>
              <Button
                disabled={isDisabled}
                onClick={() => this.onStartGame()}
                className="rounded gah-start-btn"
                color="success"
              >
                {this.props.startButtonText}{" "}
                <img src={Play} className="play-icon" alt="" />
              </Button>
            </div>
          </div>
        ) : (
          <div className="gParameter">
            <p className="h-text">
              <span>{this.props.gameParamText}</span>
            </p>
            <div className="wrapper">
              {/* <CardClip /> */}
              <div className="gParameterRow">
                {/* <div className="d-flex flex-column">
                    <h4 className="tw-bottom-txt">ratings</h4>
                    <div className="tw-rounds">
                      <p className="round-num">PG</p>
                      <img src={arrowDown} alt="" />
                    </div>
                  </div>
                  <label class="toggle">
                    <input type="checkbox" />
                    <span class="slider"></span>
                    <span class="labels" data-on="ON" data-off="OFF"></span>
                  </label> */}
                <div className="blank-div"></div>
                <div className="roundWrapper">
                  <h3 className="round-txt">rounds</h3>
                  <div className="round">
                    <div className="counter">
                      <button
                        onClick={() =>
                          this.props.onAddOrSubtractRound("subtract", false)
                        }
                      >
                        -
                      </button>
                      <FormGroup>
                        <Input
                          min="1"
                          max="12"
                          name="round"
                          onChange={(evt) => this.handleChange(evt)}
                          value={roundsForMapp}
                          disabled
                        />
                      </FormGroup>
                      <button
                        onClick={() =>
                          this.props.onAddOrSubtractRound("add", false)
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  className="d-flex flex-column justify-content-end align-items-end"
                  style={{ width: "33.3333%" }}
                >
                  <div
                    className="tw-start-btn-wrapper"
                    disabled={isDisabled}
                    onClick={() => this.onStartGame()}
                  >
                    <div className="tw-start-btn">
                      {this.props.startButtonText}
                    </div>
                  </div>
                </div>

                {gameName === "GAH" && (
                  <div className="d-flex align-items-center">
                    <div className="selectWrapper">
                      <p>Rating</p>
                      <FormGroup>
                        <Input
                          type="select"
                          name="rating"
                          value={this.props.rating}
                          onChange={(evt) => this.handleChange(evt)}
                        >
                          {options &&
                            options.length > 0 &&
                            options.map((option, index) => {
                              const optionValue = option;
                              return (
                                <option key={index} value={option}>
                                  {optionValue}
                                </option>
                              );
                            })}
                        </Input>
                      </FormGroup>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div>
              <Row className="mt-3">
                {isCreateRoom && (
                  <Col md={12} className="mb-4">
                    <Button
                      onClick={() => this.onStartGame()}
                      className="w-100 b-shadow"
                      color="success"
                    >
                      Create Room
                    </Button>
                  </Col>
                )}
                {
                  <>
                    {/* <Col md={6} className="mb-md-0 mb-3">
                      <Button onClick={() => this.props.onBack()} className="w-100 rounded">
                        {this.props.backButtonText}
                      </Button>
                    </Col>
                    <Col md={6}>
                      <Button
                        disabled={isDisabled}
                        onClick={() => this.onStartGame()}
                        className="w-100 mb-2 rounded"
                        color="success"
                      >
                        {this.props.startButtonText}
                      </Button>
                    </Col> */}
                  </>
                }
              </Row>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  loaderDetails: state.loaderDetails,
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
  webUrlReducer: state.webUrlReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    endGame: (data) => dispatch(gameAction.endGame(data)),
    getGameData: (data) => dispatch(paramsAction.getGameData(data))
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(GameData);
